import {DEVICE_TYPES} from './constants'
import {breakpointsNumeric as breakpoints} from '../theme/config'

export default (width) => {
  if (width < breakpoints.tiny) {
    return DEVICE_TYPES.SMARTPHONE
  }
  if (width < breakpoints.small) {
    return DEVICE_TYPES.PHABLET
  }
  if (width < breakpoints.medium) {
    return DEVICE_TYPES.TABLET
  }
  if (width < breakpoints.large) {
    return DEVICE_TYPES.LAPTOP
  }
  return DEVICE_TYPES.DESKTOP
}
